<template>
  <div>
    <div class="mb-7 pa-3">
      <TeacherFilter :viewIsPaid="viewIsPaid" @onFilter="handleFilter" />
    </div>
    <v-card>
      <v-data-table
        mobile-breakpoint="0"
        item-key="id"
        :options.sync="pagination"
        :items-per-page="10"
        :server-items-length="totalItems"
        :headers="headers"
        :footer-props="footerTable"
        :items="listReports"
        sort-by="name"
        v-bind="this.$attrs"
        loading-text="Đang Tải"
        :loading="loading"
        :hide-default-footer="!listReports[0]"
        disable-sort
      >
        <template v-slot:no-data>
          <EmptyData />
        </template>
        <template v-slot:[`item.stt`]="{ index }">
          {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <CardTeacher :teacher="item.teacher" link isCodeShown />
        </template>
        <template v-slot:[`item.subjectGroup`]="{ item }">
          {{ item.subjectGroup.title }}
        </template>
        <template v-slot:[`item.dob`]="{ item }">
          <span v-if="item.teacher && item.teacher.dob">{{ item.teacher.dob | ddmmyyyy }}</span>
        </template>
        <template v-slot:[`item.isPaid`]="{ item }">
          <v-icon color="#46BE8A" v-if="item.isPaid">mdi-checkbox-marked-circle</v-icon>
          <v-icon color="#F4BB43" v-else>mdi-cancel </v-icon>
        </template>
        <template v-slot:[`item.totalAfterTax`]="{ item }">
          <span>{{ item.totalAfterTax.toLocaleString('en-US') || '0' }}</span>
        </template>
        <template v-slot:[`item.note`]="{ item }">
          <v-tooltip max-width="300px" bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="note text-truncate">
                {{ item.notes }}
              </div>
            </template>
            <span class="tooltip white--text">{{ item.notes }} </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <Actions :isPaid="item.isPaid" :viewIsPaid="viewIsPaid" :report="item" />
        </template>
      </v-data-table>
      <div class="mb-7">
        <TotalPayment />
      </div>
    </v-card>
  </div>
</template>

<script>
import CardTeacher from '@/components/basic/card/CardTeacherName.vue'
import EmptyData from './EmptyData.vue'
import TeacherFilter from './TeacherFilter.vue'
import Actions from './Actions.vue'
import TotalPayment from './TotalPayment.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
const headers = [
  { text: 'STT', value: 'stt', align: 'center', width: '30px' },
  { text: 'Giáo viên', value: 'name', width: '300px' },
  { text: 'Ngày sinh', value: 'dob', width: '100px' },
  { text: 'Lĩnh vực', value: 'subjectGroup', width: '100px' },
  { text: 'Lương thực nhận', value: 'totalAfterTax', align: 'right', width: '150px' },
  { text: 'Ghi chú', value: 'note', width: '30%' },
  { text: 'Thao tác', value: 'action', align: 'center', width: '100px' }
]
export default {
  components: {
    EmptyData,
    TeacherFilter,
    CardTeacher,
    Actions,
    TotalPayment
  },
  data() {
    return {
      pagination: {},
      pageText: '',
      loading: false
    }
  },
  computed: {
    viewIsPaid() {
      return true
    },
    headers() {
      if (this.viewIsPaid) {
        headers.splice(5, 0, { text: 'Đã nhận', value: 'isPaid', align: 'center', width: '6%' })
        return headers
      }
      return headers
    },
    ...mapGetters({
      period: 'salaryPeriod/period',
      totalItems: 'salaryReport/totalItems',
      reports: 'salaryReport/reports',
      customQuery: 'salaryReport/customQuery'
    }),
    listReports() {
      if (this.period.status === 'finished') return this.reports
      return []
    },
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions({
      fetchReports: 'salaryReport/fetchReports',
      getTotalFee: 'salaryPeriod/getTotalFee',
      setTotalFeeNull: 'salaryPeriod/setTotalFeeNull',
      setReport: 'salaryReport/setReport'
    }),
    ...mapMutations('salaryReport', ['setCustomQuery']),
    calTotalMoney(totalSumFee, totalMinusFee) {
      return totalSumFee - totalMinusFee
    },
    async handleFilter(filter) {
      this.pagination.page = 1
      await this.setCustomQuery(filter)
      await this.getReportByPagination(1, this.pagination.itemsPerPage)
      let params = {
        periodId: this.period.id,
        gradeId: filter.grade ? filter.grade : null,
        isUseNote: filter.isUseNote ? filter.isUseNote : null,
        isPaid: filter.isPaid ? filter.isPaid : null
      }
      if (filter.student) {
        this.setReport(this.reports[0])
        params = { ...params, student: filter.student }
      }
      await this.setTotalFee(params)
    },
    async setTotalFee(params) {
      if (this.period.id && this.period.status === 'finished') {
        await this.getTotalFee(params)
      } else if (this.period.status === 'created') {
        this.setTotalFeeNull()
      }
    },
    setPageText(page, itemsPerPage) {
      const pageStart = (page - 1) * itemsPerPage + 1
      let pageStop = page * itemsPerPage
      pageStop = pageStop > this.totalItems || pageStop === -1 ? this.totalItems : pageStop
      this.pageText = `${pageStart}-${pageStop} trên ${this.totalItems}`
    },
    async getReportByPagination(page, itemsPerPage) {
      let params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        _sort: 'nameToNumber:ASC',
        period: this.$route.params.id,
        ...this.customQuery
      }
      this.loading = true
      await this.fetchReports(params)
      this.loading = false
      await this.setPageText(page, itemsPerPage)
    }
  },
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.getReportByPagination(newOptions.page, newOptions.itemsPerPage)
        }
      },
      immediate: true
    },
    async period() {
      let params = {
        periodId: this.period.id
      }
      await this.setTotalFee(params)
    }
  }
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}

.tooltip {
  word-wrap: break-word;
}

div.note {
  max-width: 400px;
}

@media screen and (max-width: 1597px) {
  div.note {
    max-width: 300px;
  }
}

@media screen and (max-width: 1497px) {
  div.note {
    max-width: 200px;
  }
}
</style>
